import { matchPath } from 'react-router-dom'

export function getAppFromPath(apps, path) {
  return apps.find((app) => matchPath(app.path, path))
}
